import { DicomVRMaxLength } from '~/domain/dicom/dicomConstants';
import {
    dicomStringViolation,
    hasDicomPrintableCharacters,
    hasDicomTextCharacters,
} from '~/domain/dicom/valueRepresentation';
import { DicomStructureSet } from '~/domain/dicom/dicomstructureset';

export const validateStructureSetLabel = (
    newName: string
): [boolean, string | null] => {
    // StructureSetLabel is VR SH.
    switch (dicomStringViolation(newName, DicomVRMaxLength.SHORT)) {
        case 'empty':
            return [false, 'Structure set name cannot be empty.'];
        case 'characters':
            return [
                false,
                'Structure set name contains invalid characters. Only ASCII characters are allowed.',
            ];
        case 'backslash':
            return [
                false,
                'Structure set name cannot contain backslashes (\\).',
            ];
        case 'length':
            return [
                false,
                `Structure set name must not exceed ${DicomVRMaxLength.SHORT} characters.`,
            ];
        default:
            return [true, null];
    }
};

export const validateStructureSetDescription = (
    description: string
): [boolean, string | null] => {
    // StructureSetDescription is VR ST: line breaks and the backslash are
    // content here, so only the repertoire and the length bind.
    if (!hasDicomTextCharacters(description)) {
        return [
            false,
            'Description contains invalid characters. Only ASCII characters are allowed.',
        ];
    }
    if (description.length > DicomVRMaxLength.TEXT) {
        return [
            false,
            `Description must not exceed ${DicomVRMaxLength.TEXT} characters.`,
        ];
    }
    return [true, null];
};

export const validateStructureName = (
    newName: string,
    structureNames: string[]
): [boolean, string | null] => {
    // ROIName is VR LO.
    switch (dicomStringViolation(newName, DicomVRMaxLength.LONG)) {
        case 'empty':
            return [false, 'Structure name cannot be empty.'];
        case 'characters':
            return [
                false,
                'Structure name contains invalid characters. Only ASCII characters are allowed.',
            ];
        case 'backslash':
            return [false, 'Structure name cannot contain backslashes (\\).'];
        case 'length':
            return [
                false,
                `Structure name must not exceed ${DicomVRMaxLength.LONG} characters.`,
            ];
    }
    if (
        structureNames.some((name) =>
            DicomStructureSet.structureNamesEqual(name, newName)
        )
    ) {
        return [false, 'A structure with this name already exists.'];
    }
    return [true, null];
};

/**
 * Whether `value` is non-empty and passes
 * {@link hasDicomPrintableCharacters}, which defines the repertoire.
 * Length is not checked here; callers that care check it themselves.
 */
export const hasAsciiCharactersOnly = (value: string): boolean =>
    value.trim() !== '' && hasDicomPrintableCharacters(value.trim());
